export const GRID_EVENTS = {
	UPDATE_GRID: 'UPDATE',
	UPDATE_GRID_CELL: 'UPDATE_CELL',
	UPDATE_ROWS: 'UPDATE_ROWS',
	DELETE_ROWS: 'DELETE_ROWS',
	REFRESH_GRID: 'REFRESH',
	PURGE_GRID_ROUTE: 'PURGE_GRID_ROUTE',
	CLEAR_SELECTION: 'CLEAR_SELECTION',
	EXPORT: 'EXPORT',
	DIRTY_STATE_CHANGED: 'DIRTY_STATE_CHANGED',
	/** Published by RenderInput so useAgGrid can route the edit through the bulk buffer */
	BULK_CELL_EDIT: 'BULK_CELL_EDIT',
};

export const PAGE_SIZE = 50;

/** If total row count is at or below this threshold, use clientSide row model for instant sort/filter */
export const CLIENT_SIDE_THRESHOLD = 25000;
/** Batch size when bulk-fetching all rows for client-side mode */
export const CLIENT_SIDE_FETCH_SIZE = 5000;
